/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Pdf_ExportedInputs */

const en_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF exported`)
};

const de_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF exportiert`)
};

const fr_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF exporté`)
};

const es_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF exportado`)
};

const it_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF esportato`)
};

const nl_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF geexporteerd`)
};

const pl_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF wyeksportowany`)
};

const fi_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF viety`)
};

const da_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF eksporteret`)
};

const sv_resumes_pdf_exported = /** @type {(inputs: Resumes_Pdf_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF exporterat`)
};

/**
* | output |
* | --- |
* | "PDF exported" |
*
* @param {Resumes_Pdf_ExportedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_pdf_exported = /** @type {((inputs?: Resumes_Pdf_ExportedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Pdf_ExportedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_pdf_exported(inputs)
	if (locale === "fr") return fr_resumes_pdf_exported(inputs)
	if (locale === "es") return es_resumes_pdf_exported(inputs)
	if (locale === "it") return it_resumes_pdf_exported(inputs)
	if (locale === "nl") return nl_resumes_pdf_exported(inputs)
	if (locale === "pl") return pl_resumes_pdf_exported(inputs)
	if (locale === "fi") return fi_resumes_pdf_exported(inputs)
	if (locale === "da") return da_resumes_pdf_exported(inputs)
	if (locale === "sv") return sv_resumes_pdf_exported(inputs)
	return en_resumes_pdf_exported(inputs)
});